module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Генерация ссылки для автозаполнения анкеты")]), _vm._v(" "), _c('p', [_vm._v("Введите userAccountId для генерации ссылки")]), _vm._v(" "), _c('div', {
    staticClass: "questionnaire-autofill-container"
  }, [_c('div', {
    staticClass: "centered questionnaire-autofill-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userAccountId),
      expression: "userAccountId"
    }],
    staticClass: "input shedule-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userAccountId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userAccountId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.generateAutofillLink
    }
  }, [_vm._v("\n                " + _vm._s('Сгенерировать') + "\n            ")])]), _vm._v(" "), (this.autofillLink) ? _c('p', {
    staticClass: "questionnaire-autofill-generated-link"
  }, [_vm._v("\n            Ссылка: "), _c('b', [_vm._v(_vm._s(this.autofillLink))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a92bd46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Uprid/QuestionnaireAutofill.vue
// module id = 891
// module chunks = 0